var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 d-flex align-items-center",class:_vm.dynamicClass},[_c('span',{staticClass:"material-icons md-18",class:{ 'is-checked': _vm.content }},[_vm._v(_vm._s(_vm.icon))])])}
var staticRenderFns = []

export { render, staticRenderFns }